// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import env from '../env';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// Your web app's Firebase configuration

const firebaseConfig = {
  apiKey: env.firebase_api_key,
  authDomain: env.firebase_auth_domain,
  projectId: env.firebase_project_id,
  storageBucket: env.firebase_storage_bucket,
  messagingSenderId: env.firebase_storage_bucket,
  appId: env.firebase_app_id,
};

const app = initializeApp(firebaseConfig);
export default app;
